
export default {
	name: "CrosswordClueLengthFilter",
	data() {
		return {
			scrollRef: null,
			reachedScrollLimitRight: false,
			reachedScrollLimitLeft: true,
			activeOption: null,
			scrollingInterval: null,
			DIRECTION: {
				LEFT: "left",
				RIGHT: "right",
			},
			hasOverflow: false,
		};
	},
	computed: {
		filterLengthOptions() {
			const answersLength = this.allAnswers?.map((answerObject) => {
				return answerObject.answer?.length;
			});

			const uniqueLengths = answersLength.reduce(
				(acc, current) =>
					acc.includes(current) ? acc : [...acc, current],
				[]
			);

			return uniqueLengths.sort(function (first, second) {
				return second - first;
			});
		},
		isVisible() {
			const total = this.allAnswers.length || 0;
			return (
				total > 1 &&
				(this.filterLengthOptions.length > 1 ||
					this.activeOption !== null)
			);
		},
		allAnswers() {
			return this.$store.state.clues.allAnswers;
		},
	},
	mounted() {
		const element = this.$refs.scrollRef;
		this.hasOverflow = element
			? element?.scrollWidth > element?.clientWidth
			: false;
	},
	methods: {
		startScrolling(direction) {
			// Scroll once in the case of a simple tap
			this.scrollTo(direction);
			// Scroll a little every 100ms while the button is pressed
			this.scrollingInterval = setInterval(() => {
				this.scrollTo(direction);
			}, 100);
		},
		// Clear the interval to stop scrolling when mouse button is released
		// or if the mouse leaves the button while holding it
		stopScrolling() {
			if (this.scrollingInterval) {
				clearInterval(this.scrollingInterval);
				this.scrollingInterval = null;
			}
		},
		checkOptionVisibility(event) {
			if (event) {
				const element = event.target;
				const scrollContainer = this.$refs.scrollRef;
				if (element && scrollContainer) {
					const overlaySize = this.isSmallDevice ? -40 : 42; // Size of the opaque part of the gradient overlay or the full arrow button
					const optionSize = element.getBoundingClientRect().width;
					const optionLeftLimit =
						element.getBoundingClientRect().left;
					const optionRightLimit =
						element.getBoundingClientRect().right;
					const containerRightLimit =
						scrollContainer.getBoundingClientRect().right;
					const containerLeftLimit =
						scrollContainer.getBoundingClientRect().left;
					if (optionLeftLimit < containerLeftLimit - overlaySize) {
						this.scrollTo(this.DIRECTION.LEFT, optionSize);
						return;
					}
					if (optionRightLimit > containerRightLimit + overlaySize) {
						this.scrollTo(this.DIRECTION.RIGHT, optionSize);
					}
				}
			}
		},
		applyFilter(selectedOption, event) {
			this.checkOptionVisibility(event);
			this.activeOption = selectedOption;
			this.filter(selectedOption);
		},
		filter(answerLength) {
			const filteredAnswers =
				answerLength === null
					? this.allAnswers
					: this.allAnswers.filter((answerObject) => {
							return answerObject.answer?.length === answerLength;
					  });

			this.$store.commit("clues/SET_FILTERED_ANSWERS", filteredAnswers);
		},
		scrollCallback(event) {
			const element = event.target;
			const scrollWidth = element.scrollWidth;
			const scrollX = element.scrollLeft;
			const elementWidth = element.clientWidth;

			// check left limit
			this.reachedScrollLimitLeft = scrollX <= 0;

			// check right limit
			const BUFFER_SIZE = 4;
			this.reachedScrollLimitRight =
				scrollX >= scrollWidth - elementWidth - BUFFER_SIZE;
		},
		scrollTo(direction, amount) {
			const element = this.$refs.scrollRef;
			const scrollWidth = element.scrollWidth;
			const scrollPosition = element.scrollLeft;
			const scrollAmount = amount || 100;

			if (element) {
				if (direction === this.DIRECTION.LEFT) {
					return element.scrollTo({
						top: 0,
						left: Math.max(0, scrollPosition - scrollAmount),
						behavior: "smooth",
					});
				} else if (direction === this.DIRECTION.RIGHT) {
					return element.scrollTo({
						top: 0,
						left: Math.min(
							scrollWidth,
							scrollPosition + scrollAmount
						),
						behavior: "smooth",
					});
				}
			}
		},
	},
};
